import { render, staticRenderFns } from "./DetailRitiro.vue?vue&type=template&id=4fa2b252&"
import script from "./DetailRitiro.vue?vue&type=script&lang=js&"
export * from "./DetailRitiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports